import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getLoginDto, login } from "@services/loginService";
import ModalView from "@modals/modalview/ModalView";
import phoneIcon from "@assets/icons/phone-icon.svg";
import lockIcon from "@assets/icons/password-lock.svg";
import styles from "./LoginWithPassword.module.css";
import { useDispatch } from "react-redux";
import { setComponentToShow } from "@store/ModalToShow";
import { setIsForgotPassword } from "@store/login/LoginStore";
import { environment } from "@environments/environment";

interface PasswordLoginProps {
  isOpen: boolean;
  onClose: () => void;
  // onLogin: (phone: string, password: string) => void;
  // onForgotPassword?: () => void;
  onLoginWithOtp?: () => void;
}

function LoginWithPassword({ isOpen, onClose }: PasswordLoginProps) {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const phoneNumber = localStorage.getItem("phoneNumber")??"";
  const countryCode = localStorage.getItem("countryCode");
  const displayNumber = `${countryCode} ${phoneNumber}`;

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
  };

  const handleLogin = async () => {
    setError("");

    // localStorage.clear();

    try {
      const res = await login(
        { phone: phoneNumber, password: password },
        "+91"
      );

      if (res && res.accessToken) {
        onClose();
        localStorage.setItem("accessToken", res.accessToken);

        const dtoResp = await getLoginDto(res.accessToken);
        const data = dtoResp ? dtoResp[0] : null;
        const roles = data?.roles || [];

        const matchedRole = roles.find(
          (role: any) => role.roleId === environment.ROLE_IDS.ADMIN || role.roleId === environment.ROLE_IDS.EVALUATOR
        );

        const roleId = matchedRole?.roleId;
        console.log("roleId", roleId);
        console.log("User logged in:", data);

        localStorage.setItem("roleId", roleId);
        if (roleId == environment.ROLE_IDS.EVALUATOR) {
          navigate("/evaluator-dashboard");
        } else if (roleId == environment.ROLE_IDS.ADMIN) {
          navigate("/admin-dashboard");
        }
        localStorage.setItem("userDto", JSON.stringify(dtoResp[0]));

        const _headers = {
          accesstoken: res.accessToken,
          studentid: phoneNumber,
        };
      } else {
        setError("Incorrect Password! Try again");
      }
    } catch (err: any) {
      // console.error("Login error:", err);
      setError(err?.message || "Incorrect Password! Try again");
    }
  };

  const handleLoginWithOtp = () => {
    dispatch(setComponentToShow("SendOtp"));
  };

  const handleForgotPassword = () => {
    dispatch(setIsForgotPassword(true));
    dispatch(setComponentToShow("SendOtp"));
  };

  return (
    <ModalView isOpen={isOpen} onClose={onClose}>
      <div className={styles.modalOverlay}>
        <div className={styles.modalContainer}>
          <div className={styles.modalHeader}>
            <h2>Password Login</h2>
            <button className={styles.closeBtn} onClick={onClose}>
              &times;
            </button>
          </div>
          <p className={styles.subText}>
            Please enter your registered phone number and password to get
            started
          </p>

          <form onSubmit={handleSubmit} className={styles.form}>
            <div className={styles.inputGroup}>
              <img src={phoneIcon} className={styles.icon} />
              <input
                type="tel"
                value={displayNumber}
                className={styles.input}
                readOnly
              />
            </div>

            <div className={styles.inputGroup}>
              <img src={lockIcon} className={styles.icon} />
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                placeholder="Password"
                onChange={(e) => setPassword(e.target.value)}
                className={styles.input}
              />
              <button
                type="button"
                className={styles.eyeBtn}
                onClick={() => setShowPassword((prev) => !prev)}
              >
                {showPassword ? "🙈" : "👁️"}
              </button>
            </div>
            <div className={styles.error}>{error}</div>
            {
              <button
                type="button"
                className={styles.forgotPassword}
                onClick={handleForgotPassword}
              >
                FORGOT PASSWORD?
              </button>
            }

            <button
              type="submit"
              className={styles.loginBtn}
              onClick={handleLogin}
            >
              LOGIN
            </button>

            {
              <button
                type="button"
                className={styles.loginWithOtp}
                onClick={handleLoginWithOtp}
              >
                LOGIN WITH OTP
              </button>
            }
          </form>
        </div>
      </div>
    </ModalView>
  );
}

export default LoginWithPassword;
